export const environment = {
	production: false,

	loginLogoLeftUrl: 'assets/images/Panda - Icon (Dark Background).png',

	loginLogoRightUrl: 'assets/images/Panda - Icon (Dark Background).png',

	loginImageLeftUrl: 'assets/images/kula-logo.png',

	loginImageRightUrl: 'assets/images/Panda Vertical Logo.png',

	ticketListShowMembershipColumn: true,
	ticketListShowTicketReferenceColumn: true,
	createMemberTicketWithoutCategory: false,
	enableProductAndPolicy: false,
	showWorkflowSectionClaims: false,
	showWorkflowSectionComplaints: true,
	showWorkflowSectionCases: true,
	enablePoh: false,
};
